<template>
    <el-autocomplete
        v-model="autoValue"
        :fetch-suggestions="querySearchAsync"
        :placeholder="placeholder"
        :style="{width: width}"
        :size="size"
        @input="handleChange">
    </el-autocomplete>
</template>
<script>
    /**
     * 输入框搜索组件，与auto-search不同的是，绑定的值是指定的一个字断，不是一个对象
     * @author zjs
     * @time 2018-03-21
     */
    import LyAutoInput from '@c/autoinput'
    export default {
        name: 'LyAutoSelect',
        components: {
            LyAutoInput
        },
        props: {
            // 绑定的是基本类型字段
            value: [String, Number],
            placeholder: {
                type: String,
                default: '请输入'
            },
            size: {
                type: String,
                default: 'small'
            },
            width: {
                type: String,
                default: '220px'
            },
            /**
             {
                api 接口请求地址
                isQuery 初始化获得数据后，是否继续查询数据
                realSearch 是否实时搜索数据
             }
             */
            json: Object,
            watchField: { // 监听变化的值，也作为搜索的参数
                type: [String, Number, Object]
            }
        },
        data () {
            return {
                autoValue: '',
                realSearch: true, // 标识是否实时搜索数据
                datalist: [] // 搜索出来的数据结果
            }
        },
        watch: {
            value (v) {
                this.refAutoValue(v)
            },
            /**
             * 搜索关联字段，值变化的监听
             * @param  {[type]} v [description]
             * @return {[type]}   [description]
             */
            watchField (v) {
                if (v) {
                    this.realSearch = true
                }
            }
        },
        created () {
            this.refAutoValue(this.value)
            // 设置是否实时搜索的状态
            this.setRealSearch()
        },
        methods: {
            setRealSearch () {
                if (this.json.realSearch === false) {
                    this.realSearch = false
                }
            },
            /**
             * 更新autoValue的值
             */
            refAutoValue (v) {
                if (v && v !== this.autoValue) {
                    this.autoValue = v
                }
            },
            /**
             * 数据的读取
             * @return {[type]} [description]
             */
            querySearchAsync (keyword, callback) {
                if (this.realSearch) {
                    this.setRealSearch()
                    // 设置搜索的值
                    let searchData = this.watchField ? this.watchField : {}
                    searchData['keyword'] = keyword
                    this.timer && clearTimeout(this.timer)
                    this.timer = setTimeout(() => {
                        console.log(this)
                        this.$api.query(this.json.api, this.watchField).then((rs) => {
                            this.datalist = rs
                            callback(rs)
                        }).catch((err) => {
                            console.error('auto-select query error:%O', err)
                        })
                    }, 800)
                } else {
                     callback(this.datalist)
                }
            },
            handleChange (val) {
                if (val !== this.value) {
                    this.$emit('input', val)                
                }
            }
        }
    }
</script>